import axios from 'axios';
import apiroutes from '@/API/ApiRoutes';


const state = {};

const getters = {};

const actions = {

  GetDonorList({commit}, payload) {

    return new Promise((resolve, reject) => {
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth){
        tok= 'Bearer '+auth.access_token;
      }else{
        tok= '';
      }

      let authheader = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        Authorization : tok
      };

      axios.get(apiroutes.routes.donors, {headers: authheader})
        .then((response) => {
          console.log('apidata',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  GetDonorListAccordingToBloodGroup({commit}, payload) {

    return new Promise((resolve, reject) => {
      console.log('asdas')
      let tok = '';
      let auth = JSON.parse(localStorage.getItem('auth-response'));
      if (auth){
        tok= 'Bearer '+auth.access_token;
      }else{
        tok= '';
      }

      let authheader = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        Authorization : tok
      };

      axios.get(apiroutes.routes.blood_donors_with_blood_group +'?blood_group_id=' + payload , {headers: authheader})
        .then((response) => {
          console.log('apidata',response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
